/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { IVariablesNamespace } from '.'
 * @import CommunicatorSettings from '../communicator/settings/communicator-settings'
 */

/** @implements {IVariablesNamespace} */
export default class UserVariablesNamespace {
  /**
   * @param {CommunicatorSettings} communicatorSettings
   */
  constructor(communicatorSettings) {
    this.communicatorSettings = communicatorSettings;
  }

  /** @type {IVariablesNamespace['getValue']} */
  getValue(key) {
    return this.communicatorSettings.get(`user.${key}`);
  }
}
